/** 用户协议 */
<template>
  <div class="home protocol-home">
    <Header type='protocol-header' />
    <div class="protocol-contnet">
      <div class='protocol-detail'>
        <h1 class="v1">User Agreement For BonusCloud </h1>
        <b class="v2">Contents</b>
        <p class="v3">1. Introduction</p>
        <p class="v3">2. Protection of Personal Information</p>
        <p class="v3">3. Collection of Personal Information</p>
        <p class="v3">4. Purposes for Collection of Personal Information</p>
        <p class="v3">5. Ours Ways of Using Your Information</p>
        <p class="v3">6. Parties That We Might Share Your Information With</p>
        <p class="v3">7. Cookies</p>
        <p class="v3">8. Security Measures</p>
        <p class="v3">9. Your Rights to the Information We Hold About You</p>
        <p class="v3">10. Sharing Data Directly With Third Parties</p>
        <p class="v3">11. Third-party Link</p>
        <p class="v3">12. Updates about This Policy</p>
        <b class="v2">1. Introduction</b>
        <p>BonusCloud Foundation (hereinafter referred to as "we/us/our" or "BonusCloud”) are committed to privacy of you ("you" refers to users of BonusCloud). This User agreement applies to the access and use of the BonusCloud Services provided at https://bonuscloud.io and its subdomains and such other sites (hereinafter referred to as "BonusCloud Website") as may be designated by BonusCloud.</p>
        <p>The User agreement sets out how we collect, aggregate, store, process, clean, structure and encrypt your personal data (your personal information) in connection with our business. It also explains what rights you have to access or change your personal data.</p>
        <p class="notice"><strong>NOTICE: PLEASE NOTE THAT VISITING BONUSCLOUD WEBSITE, CONNECTING YOUR DEVICES INTO OUR PLATFORM OR USING OUR SERVICES MEANS YOU HAVE READ, LEARNT AND AGREED TO ACCEPT THIS USER AGREEMENT. THIS POLICY IS VALID DURING THE WHOLE PROCESS OF USAGE OF BONUSCLOU WEBSITE AND OUR SERVICES. IF YOU DO NOT AGREE WITH THIS POLICY, YOU SHALL STOP USING BONUSCLOUD WEBSITE, CONNECTING YOUR DEVICE(S) INTO OUR PLATFORM AND USING VARIOUS SERVICES DESCRIBED IN DETAILS AS BELOW IMMEDIATELY.</strong></p>
        <p>If you have any question, advice or complaint to our User agreement, please contact: <strong>business@muhuakeji.com</strong>.</p>

        <b class="v2">2. Protection of Personal Information</b>
        <p class="v3">2.1 We are committed to the security of your personal information. Our online services use encryption technologies such as Transport Layer Security Protocol (TLS) to protect your personal information during transmission. When you store your personal data in BonusCloud, we use computer systems with limited access rights. These systems are deployed in the facilities protected by physical safety measures and we use the third-party storage space by the same measures.</p>

        <p class="v3">2.2 When you use the products, services or applications of BonusCloud, or post in the forum, chat rooms or social media provided by BonusCloud, your personal information and contents shared by you will be seen by other users, which means they might read, collect or use your personal information. You are responsible to the your own behaviors of sharing and uploading your personal information. For example, when you post your name and email address in the forum, the information will be open to the public. Please be careful and cautious when you use such functions.</p>

        <p class="v3">2.3 If you and any other user who logs in your account by devices owned by third party, some of the information related to your account might be downloaded in the third-party devices, which might cause the leakage of such shared information.</p>

        <b class="v2">3. Collection of Personal Information</b>

        <p class="v3"><strong>3.1 Information that you provide to us.</strong></p>

        <p class="v3">3.1.1 We will collect any information that you provide to us when you:</p>

        <p class="v3">•	(a) make an enquiry, provide feedback or make a complaint by email,on our website or via our media platform whether that is about our services or any other matter;</p>
        <p class="v3">•	(b) submit correspondence to us by email or via BonusCloud Website;</p>
        <p class="v3">•	(c) update your profile;</p>
        <p class="v3">•	(d) subscribe to our newsletter and mailing lists;</p>
        <p class="v3">•	(e) fill in a form, conduct a search, respond to surveys, participate in promotions or use any other features of the website;</p>
        <p class="v3">•	(f) register to and/or attend our events;</p>
        <p class="v3">•	(g) submit a CV or an application to a job vacancy;</p>
        <p class="v3">•	(h) attend an interview or assessment; and</p>
        <p class="v3">•	(i) ‘follow’, ‘like’, post to or interact with our digital platforms, forums, blogs and social media accounts, including GitHub, Twitter, Facebook, Telegram, Reddit, Medium, Blogger, Wechat and any other social media of ours.</p>

        <p class="v3"><strong>3.1.2 The information you provide to us will include (depending on the circumstances):</strong></p>

          <p class="v3">•	(a) Identity and contact data:</p>
        <p class="v3">title, names, addresses, email addresses and phone numbers, and we may also collect proof of identity if applicable;</p>

          <p class="v3">•	(b) Employment and background data:</p>
        <p class="v3">If you are submitting a job application, you may also provide additional information about your academic and work history, qualifications, skills, projects and research that you are involved in, references, proof of your entitlement to work in China, your certificate of identification; your passport or other identity document details and any other such similar information that you may provide to us; and</p>

          <p class="v3">•	(c) Survey data:</p>
        <p class="v3">from time to time we might ask if you would be willing to participate in our surveys; if you agree, we will also collect any information that you provide as part of that survey.</p>

        <p class="v3"><strong>3.1.3 Information we collect about you:</strong></p>

          <p class="v3">•	Information contained in correspondence:</p>
        <p class="v3">we will collect any information contained in any correspondence between us. </p>

          <p class="v3">•	Information transmitted on the website:</p>
        <p class="v3">we will collect information that you upload or post to your website account and/or any correspondence or interactions that you may have with other website users;</p>

          <p class="v3">•	Website usage and technical data:</p>
        <p class="v3">we will also collect certain information about how you use our website and the device that you use to access our website, even where you have not created an account or logged in. This might include your geographical location, device information (such as your hardware model, mobile network information), the data transmitted by your browser (such as your IP address, date and type of the request, content of the request regarding the specific site, time zone settings, access status/HTTP status code, volume of data transmitted, browser type and version, language settings, time zone settings referral source, length of visit to the website, date and time of the request, operating system and interface) number of page views, the search queries you make on the website and similar information. This information may be collected by a third-party website analytics service provider on our behalf and/or may be collected using cookies or similar technologies. </p>

        <p class="v3">•	Services Usage Data</p>
        <p class="v3">Apart from the information your offer, when you use our services, we also collect and store related information by the software in your devices or by other measures. We collect data such as:</p>
        <p class="v3">•	Device information such as, the hardware type, MAC address, IP address, operating system version and the device settings to access to the services. </p>
        <p class="v3">•	Log information such as the service time and the duration time.</p>
        <p class="v3">•	Location information such as related information of the geographical location of IP address of the device, which might be transmitted to us when you use certain services.</p>

        <b class="v2">4. Purposes for Collection of Personal Information</b>
        <p class="v3">We collect your personal information for any of the following purposes:</p>

        <p class="v3">4.1. to process your registration as a user, providing you with a user ID for our BonusCloud Platform and maintaining your registration;</p>
        <p class="v3">4.2. to provide, operate, optimize and maintain the services;</p>
        <p class="v3">4.3. to provide you with customer service and respond to your queries, feedback, claims or disputes;</p>
        <p class="v3">4.4. to manage the BonusCloud Platform, system administration and security;</p>
        <p class="v3">4.5. to compile aggregated statistics about the operation and use of the services and to better understand your preferences;</p>
        <p class="v3">4.6. to send you technical alerts, reports, updates, security notifications and other service-related communications;</p>
        <p class="v3">4.7. to carry out research and development to improve our products and services;</p>
        <p class="v3">4.8. to send you marketing communications (where this is in accordance with Your communication preferences);</p>
        <p class="v3">4.9. to perform screening and checks for unlawful, fraudulent, deceptive or malicious activities;</p>
        <p class="v3">4.10. to comply with applicable law, legal process or lawful government request, or in respect of any claims or potential claims brought against us or our shareholders</p>
        <p class="v3">4.11. to carry out other legitimate business purposes, as well as other lawful purposes about which we will notify you.</p>

        <p class="v2">5. Ours Ways of Using Your Information </p>

        <p class="v3"><strong>5.1 We will use your information for the purposes listed below either on the basis of:</strong></p>

          <p class="v3">•	5.1.1 performance of your contract with us and the provision of our services to you;</p>
          <p class="v3">•	5.1.2 your consent (where we request it);</p>

        <p class="v3">5.2 We use your information for the following purposes:</p>

          <p class="v3">•	5.2.1 to provide access to our website:</p>
        <p class="v3">to provide you with access to our website in a manner convenient and optimal and with personalized content relevant to you including sharing your information with our website hosts and developers (on the basis of our legitimate interest to ensure our website is presented in an effective and optimal manner);</p>

          <p class="v3">•	5.2.2 to register your account:</p>
        <p class="v3">when you sign up to use our website, we will use the details provided on your account registration form.</p>

          <p class="v3">•	5.2.3 to process and facilitate transactions with us:</p>
        <p class="v3">we will use your information to process transactions and payments, and to collect and recover money owed to us.</p>

          <p class="v3">•	5.2.4 for relationship management:</p>
        <p class="v3">to manage our relationship with you, which will include notifying you about changes to our terms of use or user agreement, and asking you to leave a review or take a survey.</p>

          <p class="v3">•	5.2.5 for user and customer support:</p>
        <p class="v3">to provide customer service and support, deal with enquiries or complaints about the website and share your information with our website developer, IT support provider, payment services provider and any other service provider to provide customer support.</p>

          <p class="v3">•	5.2.6 for reward draws, competitions and surveys:</p>
        <p class="v3">to enable you to take part in reward draws, competitions and surveys (on the basis of our legitimate interest in studying how our website and services are used);</p>

          <p class="v3">•	5.2.7 for recruitment:</p>
        <p class="v3">to process any job applications you submit to us, whether directly or via an agent or recruiter including sharing this with our third party recruitment agency.</p>

          <p class="v3">•	5.2.8 for marketing:</p>
        <p class="v3">to keep in contact with you about our news, events, new website features products or services that we believe may interest you.</p>

          <p class="v3">•	5.2.9 for advertising:</p>
        <p class="v3">to deliver relevant website content and advertisements to you and measure or understand the effectiveness of the advertising we serve to you.</p>

          <p class="v3">•	5.2.10 For social media interactions:</p>
        <p class="v3">to interact with users on social media platforms including Twitter, Facebook, Telegram, and Wechat for example, responding to comments and messages, posting, ‘retweeting’ and ‘liking’ posts.</p>

          <p class="v3">•	5.2.11 For analytics:</p>
        <p class="v3">to use data analytics to improve our website, products/services, marketing, customer relationships and experiences.</p>

          <p class="v3">•	5.2.12 For suggestions and recommendations:</p>
        <p class="v3">to share your information with selected third parties such as suppliers and partners, to enable them to contact you with information about things that may interest you (where we have your consent to do so);</p>

          <p class="v3">•	5.2.13 For research:</p>
        <p class="v3">to carry out aggregated and anonymized research about general engagement with our website.</p>

          <p class="v3">•	5.2.14 For fraud and unlawful activity detection:</p>
        <p class="v3">to protect, investigate, and deter against fraudulent, unauthorized, or illegal activity, including identity fraud.</p>

          <p class="v3">•	5.2.15 For compliance with policies, procedures and laws:</p>
        <p class="v3">to enable us to comply with our policies and procedures and enforce our legal rights, or to protect the rights, property or safety of our employees and share your information with our technical and legal advisors.</p>

        <p class="v3">5.3 As outlined above, in certain circumstances we may use your personal information to pursue legitimate interests of our own or those of third parties. Where we refer to using your information on the basis of our “legitimate interests”, we mean our legitimate business interests in conducting and managing our business and our relationship with you, including the legitimate interest we have in:</p>

        <p class="v3">5.3.1 personalizing, enhancing, modifying or otherwise improving the services and/or communications that we provide to you;</p>

        <p class="v3">5.3.2 detecting and preventing fraud and operating a safe and lawful business; and</p>

        <p class="v3">5.3.3 improving security and optimization of our network, sites and services.</p>

        <p class="v3">5.4 Where we use your information for our legitimate interests, we make sure that we take into account any potential impact that such use may have on you. Our legitimate interests don’t automatically override yours and we won’t use your information if we believe your interests should override ours unless we have other grounds to do so (such as your consent or a legal obligation). If you have any concerns about our processing please refer to details of “Your Rights” in paragraph 8 below.</p>

        <b class="v2">6. Parties That We Might Share Your Information With</b>

        <p class="v3">6.1 In connection with the purposes and on the lawful grounds described above and in addition to the recipients of your information as described above, we will share your personal information when relevant with third parties such as:</p>

        <p class="v3">6.1.1 Our service providers:</p>

        <p class="v3">service providers we work with to deliver our business, who are acting as processors and provide us with:</p>

          <p class="v3">•	(a) IT, support, system administration and security services</p>
          <p class="v3">•	(b) marketing and advertising services, analytics providers, email marketing services </p>
          <p class="v3">•	(c) identity verification, fraud prevention and detection services </p>
          <p class="v3">•	(d) legal, accountancy, auditing and insurance services and other professional advisers </p>

        <p class="v3">6.1.2 Regulators and governmental bodies:</p>

        <p class="v3">Based on laws and regulations, legal procedures, litigation or mandatory requirements of government authorities, we guarantee that, on the premise of conformity with laws and regulations, when we receive any of the above requests for disclosure of information, we will require the corresponding legal documents to be issued.</p>


        <p class="v3">6.1.3 Marketing parties:</p>

        <p class="v3">any selected third party that you consent to our sharing your information with for marketing purposes; and</p>

        <p class="v3">6.1.4 Other third parties (including professional advisers):</p>

        <p class="v3">any other third parties (including legal or other advisors, regulatory authorities, courts, law enforcement agencies and government agencies) where necessary to enable us to enforce our legal rights, or to protect the rights, property or safety of our employees or where such disclosure may be permitted or required by law.</p>

        <p class="v3">6.2 We require third parties to maintain appropriate security to protect your information from unauthorized access or processing.</p>

        <b class="v2">7. Cookies</b>

        <p class="v3">We use cookies to ensure that you get the most out of our website. Cookies are small amounts of information in the form of text files which we store on the device you use to access our website. Cookies allow us to monitor your use of the software and simplify your use of the website. </p>

        <b class="v2">8. Security Measures </b>

        <p class="v3">8.1 We pay reasonable attention to the security of your information and use technical, physical, and security management measures to provide personal information with appropriate protection from loss, misuse, unauthorized access, sharing and changes. </p>

        <p class="v3">8.2 We conduct security measures (listed as belows) and will organize training courses related to security and privacy protection for our employees, in order to increase their awareness of protecting personal information.</p>
          <p class="v3">•	8.1.1 firewalls, data encryption</p>
          <p class="v3">•	8.1.2 data backup measures</p>
          <p class="v3">•	8.1.3 data center access restrictions</p>
          <p class="v3">•	8.1.4 employee confidentiality agreements and security management systems</p>
          <p class="v3">•	8.1.5 identification information for mobile terminals.</p>

        <p class="v3">8.3 Although we are committed to the security of our systems and services, it is your responsibility to ensure the security and privacy of your passwords and account/user information and we strongly suggest you also play a part in keep your information safe by:</p>
          <p class="v3">•	8.3.1. choosing a strong account password and changing it regularly;</p>
          <p class="v3">•	8.3.2. using different passwords for different online accounts;</p>
          <p class="v3">•	8.3.3. keeping your login and password confidential and avoiding sharing these details with others;</p>
          <p class="v3">•	8.3.4. making sure you log out of the website each time you have finished using it. This is particularly important when using a shared computer;</p>
          <p class="v3">•	8.3.5. letting us know if you know or suspect that your account has been compromised, or if someone has accessed your account without your permission;</p>
          <p class="v3">•	8.3.6. keeping your devices protected by maintaining any necessary anti-virus software;</p>
          <p class="v3">•	8.3.7. being vigilant to any fraudulent emails that may appear to be from us. Any emails that we send will come from an email address ending in business@muhuakeji.com</p>

        <p class="v3">8.4 Nevertheless, You should also know and agree that no data transmission over the internet or any wireless network can be guaranteed to be perfectly secure.  It is still possible that such information may be stolen, illegally possessed or abused, which probably leads to the danger of your loss in personal, property and reputation. You understand and accept to take the foregoing risks.</p>

        <b class="v2">9. Your Rights to the Information We Hold About You</b>

        <p class="v3"><strong>9.1 You have certain rights in respect of the information that we hold about you, including:</strong></p>

        <p class="v3">9.1.1 the right to be informed of the ways in which we use your information, as we seek to do in this User agreement;</p>

        <p class="v3">9.1.2 the right to ask us not to process your personal data for marketing purposes;</p>

        <p class="v3">9.1.3 the right to request access to the information that we hold about you;</p>

        <p class="v3">9.1.4 the right to request that we correct or rectify any information that we hold about you which is out of date or incorrect;</p>

        <p class="v3">9.1.5 the right to withdraw your consent for our use of your information in reliance of your consent；</p>

        <p class="v3">9.1.6 the right to object to our using your information on the basis of our legitimate interests；</p>

        <p class="v3">9.1.7 in certain circumstances, the right to ask us to limit or cease processing or erase information we hold about you; and</p>

        <p class="v3"><strong>9.2 How to exercise your rights</strong></p>

        <p class="v3">9.2.1 You may exercise your rights above by contacting us by sending email to business@muhuakeji.com.</p>

        <p class="v3">9.2.2 Please note that we may need to retain certain information for our own record-keeping and research purposes. We may also need to send you service-related communications relating to your user account even when you have requested not to receive marketing communications.</p>

        <p class="v3"><strong>9.3 What we need from you to process your requests</strong></p>

        <p class="v3">9.3.1 We may need to request specific information from you to help us confirm your identity and to enable you to access your personal data (or to exercise any of your other rights). This is a security measure to ensure that personal data is not disclosed to any person who has no right to receive it. We may also contact you to ask you for further information in relation to your request to speed up our response.</p>

        <p class="v3">9.3.2 You will not have to pay a fee to access your personal data (or to exercise any of the other rights). However, we may charge a reasonable fee if your request is clearly unfounded, repetitive or excessive. Alternatively, we may refuse to comply with your request in these circumstances. </p>

        <b class="v2">10. Sharing Data Directly With Third Parties</b>

        <p class="v3">10.1 You might end up providing personal information directly to third parties as a consequence of your interactions with our website and other services offered by us. For example, you may attend an event hosted by us where you communicate personal information directly with other attendees. We are not responsible for how such third parties use personal data provided by you.</p>

        <p class="v3">10.2 Please be responsible with personal information of others when using our website and the services available on it. We are not responsible for your misuse of personal information, or for the direct relationship between you and others when takes place outside of the website or our services.</p>

        <b class="v2">11. Third-party Link</b>

        <p class="v3">The website may include links to third-party websites, plug-ins and applications. Clicking on those links or enabling those connections may allow third parties to collect or share data about you. We do not control these third-party websites and are not responsible for their privacy statements. When you leave our website, we encourage you to read the privacy notice of every website you visit.</p>

        <b class="v2">12. Updates about This Policy</b>

        <p class="v3">The User agreement will become immediately effective once posted on BonusCloud Website. We may also at our discretion provide notice to you of any changes to the User agreement. We encourage you to regularly check back on BonusCloud website to ensure that you are up to date with any changes.</p>

        <p class="v3">If You have any questions or concerns regarding to the use or disclosure of your information, You can contact us by sending an email to business@muhuakeji.com.</p>

        <p class="v3"><strong>This Privacy Notice was updated on 5, December 2018.</strong></p>

      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Layout from '@/components/DatePanel/Layout.vue'
import BasiceLayout from '@/components/Common/BasicLayout.vue'
import { mapActions, mapState } from 'vuex'
import Footer from '@/components/Common/Footer.vue'

export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    Header,
    Layout,
    BasiceLayout,
    Footer
  },
}
</script>

<style  lang="stylus">

@media (min-width: 992px) {
  .protocol-wrap  {
      max-width: 940px!important;
  }
}

@media (min-width: 768px) {
  .protocol-wrap {
      max-width: 720px;
  }
}

@media (min-width: 544px){
   .protocol-wrap  {
    max-width: 576px;
  }
}

.protocol-contnet   
  width: 50%;
  max-width: 1140px;
  text-align:left;
  margin: 40px auto 80px;
  padding-left: 15px;
  padding-right: 15px;
  text-align: justify;
  text-align: justify;
  color: #fff;
  letter-spacing: 0.5px;
  font-family: "Montserrat", Sans-serif;
  color: #ffffff;
  letter-spacing: 0.5px;
.protocol-contnet p  
  margin: 0 0 15px 0;
  font-weight: 400;
  font-size: 16px;
  color: #d1d3d6;
  font-family: "Montserrat", sans-serif;
  line-height: 1.625;
  -webkit-font-smoothing: antialiased;
.protocol-contnet  .v1
  font-size: 40px;
  margin-bottom: 30px;
  font-weight: 600;

.protocol-contnet .v2
  font-size: 18px;
  display: inline-block;
  padding: 30px 0 20px;

.protocol-contnet  .v3 
  font-weight: 400;
  font-size: 16px;
  color: #d1d3d6;
  font-family: "Montserrat", sans-serif;
  line-height: 1.625;
  -webkit-font-smoothing: antialiased;
.protocol-contnet .notice
  margin: 20px;
  padding: 5px;

.header-logo {
    width: 130px;
    height: 23.5px;
    margin: 19px 25px;
}

.header 
  width: 50%; 
  /* margin: 40px auto; */
  padding-left: 15px;
  padding-right: 15px;
  margin: 0 auto;
  text-align: left;

.protocol-home.home
  height: auto!important;
</style>
